import { render, staticRenderFns } from "./AbstractType2.vue?vue&type=template&id=8e6b0446&scoped=true"
import script from "./AbstractType2.vue?vue&type=script&lang=js"
export * from "./AbstractType2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6b0446",
  null
  
)

export default component.exports